import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetPricing, successGetPricing } from './PricingSlicer';
import { PayloadAction } from '@reduxjs/toolkit';
import { successAddPricing, failureAddPricing } from './AddPricingSlicer'
import { successUpdatePricing, failureUpdatePricing } from './UpdatePricingSlicer'
import { successDeletePricing, failureDeletePricing } from './DeletePricingSlice'

import { IPricingList, IPricingListAdd } from '../../../Pages/Pricing/IPricing';

const OwnerApi = (action: PayloadAction<any>) => {
  return api.get(`/price-structures/location/${action.payload}`);
};

export function* pricingCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(OwnerApi, action);
    yield put(successGetPricing(response.data));
  } catch (error) {
    yield put(failureGetPricing(error));
  }
}

// add owner
const AddOwnerApi = (action: PayloadAction<IPricingList>) => {
  console.log(action.payload);

  const data = {
    name: action.payload.name,
    dayTimeStart: action.payload.dayTimeStart,
    dayTimeEnd: action.payload.dayTimeEnd,
    location_id: action.payload.location_id,
  };
  return api.post("/price-structures/create", data);
};

export function* AddpricingCall(action: PayloadAction<IPricingList>) {
  try {
    console.log("AddOwnerCall");

    const response: AxiosResponse = yield call(AddOwnerApi, action);
    yield put(successAddPricing(response.data));
  } catch (error) {
    yield put(failureAddPricing(error));
  }
}

// update owner
const UpdateOwnerApi = (action: PayloadAction<IPricingList>) => {
  const url = `/price-structures/${action.payload._id}`;

  if (action.payload.structureUpdate) {
    const data = {
      name: action.payload.name,
      dayTimeStart: action.payload.dayTimeStart,
      dayTimeEnd: action.payload.dayTimeEnd,
    };
    return api.patch(url, data);
  }

  const data = {
    area: {
      name: action?.payload?.name,
      hourlyRate: action?.payload?.regularArea_HourlyRate,
      dayTimeCap: action?.payload.regularDayTimeCap,
      nightTimeCap: action?.payload?.regularNightTimeCap,
      space_type_id: action?.payload?.space_type_id,
    },
    type: action?.payload?.type,
    deleteAreaId: action?.payload?.deleteAreaId,
    isUpdate: action?.payload?.isUpdate,
    areaId: action?.payload.areaId,
    location_id: action?.payload?.location_id,
  };
  return api.patch(url, data);
};

export function* UpdatepricingCall(action: PayloadAction<IPricingList>) {
  try {
    const response: AxiosResponse = yield call(UpdateOwnerApi, action);
    yield put(successUpdatePricing(response.data));
  } catch (error) {
    yield put(failureUpdatePricing(error));
  }
}

// delete owner
const DeleteOwnerApi = (action: PayloadAction<number>) => {
  return api.delete(`/price-structures/${action.payload} `);
};
export function* DeletepricingCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteOwnerApi, action);
    yield put(successDeletePricing(response.data));
  } catch (error) {
    yield put(failureDeletePricing(error));
  }
}
